// Generated by npm run icons:build. Do not edit manually.
import { IconCategory } from './icon.types'

export const iconCategories: IconCategory[] = [
  {
    name: 'Arrows',
    icons: [
      { name: 'arrows/arrow-bottom-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-bottom-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-down-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-down-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-e', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-left-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-left-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-n', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-right-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-right-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-s', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-tool', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-top-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-top-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-up-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-up-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/arrow-w', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/backward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/block-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/block-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/block-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/block-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-arrow-bottom-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-arrow-bottom-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-arrow-top-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-arrow-top-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-caret-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-caret-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-caret-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-caret-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-ctrl-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-ctrl-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-ctrl-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/box-ctrl-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-caret-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-caret-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-caret-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-caret-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-ctrl-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-ctrl-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-ctrl-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/circle-ctrl-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/conversion', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/corner-bottom-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/corner-bottom-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/corner-top-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/corner-top-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-backward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-forward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/ctrl-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/curved-arrow-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/curved-arrow-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/curved-arrow-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/cycle', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/data-download', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/data-upload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/delete-key', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/direction-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/direction-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/direction-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/direction-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/double-arrow-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/double-arrow-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/down-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/download', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/download-data', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/download-file', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/eject', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/enlarge', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/enlarge-h', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/enter', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/expand', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/expand-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/expand-h', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/expand-window', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/export', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/file-download', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/file-upload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/format-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/format-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/forward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/fullscreen', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/increase', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/input', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/launch', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/launch-app', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/left-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/log-in', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/log-out', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/logout', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/maximize-area', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-layer-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-layer-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-layer-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-layer-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/move-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/nav-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/nav-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/nav-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/nav-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/open-in-browser', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/pointing-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/pointing-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/pointing-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/pointing-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/refresh', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/reload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/reply', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/reply-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/resize-x', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/resize-y', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/respond-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/right-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/share', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/sharing', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/sign-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/sign-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/sign-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/sign-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/slide-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/slide-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/social-sharing', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/swap-horizontal', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/swap-vertical', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/system-update', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/traffic', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/transaction', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-line-down', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-line-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-line-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-line-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/triangle-up', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/turn-e', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/turn-n', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/turn-s', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/turn-w', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/up-arrow', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/upload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/upload-data', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'arrows/upload-file', sizes: [12, 16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Business/Finance',
    icons: [
      { name: 'business-finance/address-book', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/agenda', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/algorithm', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/app-services', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/archery-target', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/atm', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/award-49', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/badge', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/bank-statement', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/bill', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/bitcoin', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/block', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/blockchain', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/board-27', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/board-28', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/board-29', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/board-30', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/books', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/briefcase-24', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/briefcase-25', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/briefcase-26', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/bulb-61', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/bulb-62', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/bulb-63', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/business-agent', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/business-contact-85', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/business-contact-86', sizes: [32, 48, 64] },
      { name: 'business-finance/business-contact-87', sizes: [32, 48, 64] },
      { name: 'business-finance/business-contact-88', sizes: [32, 48, 64] },
      { name: 'business-finance/businessman-03', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/businessman-04', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/calculator', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/candlestick-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/card-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/card-favorite', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/card-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/card-update', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/certificate', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/cloud-mining', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/cockade', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/coins', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/conference-room', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/connect', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/contactless-card', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/contacts', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/copyright', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/credit-card', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/credit-card-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/credit-locked', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/crypto-wallet', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/currency-dollar', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/currency-euro', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/currency-exchange', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/currency-exchange-2', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/currency-pound', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/currency-yen', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/debt', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/decentralize', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/decision-process', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/dice', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/factory', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/globe', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/goal-65', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/gold', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/hammer', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/hand-card', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/handout', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/handshake', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/hat', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/hierarchy-53', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/hierarchy-54', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/hierarchy-55', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/hierarchy-56', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/chart-bar-32', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/chart-bar-33', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/chart-growth', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/chart-pie-35', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/chart-pie-36', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/cheque', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/chess-knight', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/chess-tower', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/info-point', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/interview', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/joint-account', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/laptop-71', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/laptop-72', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/laptop-91', sizes: [32, 48, 64] },
      { name: 'business-finance/law', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/line-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/loan', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/logic', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/math', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/miner', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/mobile-banking', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/mobile-card', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/money-11', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/money-12', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/money-13', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/money-bag', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/money-coins', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/money-growth', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/money-time', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/money-transfer', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/mortgage', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/name-card', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/negative-judgement', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/net', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/new-construction', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/nodes', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/notes', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/office', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/office-badge', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/office-chair', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/office-pass', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/online-banking', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/payee', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/payment', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/payment-method', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/payor', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/percentage-38', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/percentage-39', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/personal-trainer', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/pig', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/pin', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/plug', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/pos', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/positive-judgement', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/presentation', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/privacy-policy', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/progress', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/puzzle-09', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/puzzle-10', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/ranking', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/rate-down', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/rate-up', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/refund', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/round-dollar', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/round-euro', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/round-pound', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/round-yen', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/safe', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/savings', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/scale', sizes: [24, 32, 48, 64] },
      { name: 'business-finance/sign', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/signature', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/statistics', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/stock-market', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/tactic', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/temple', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/tie-01', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/tie-02', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/transaction', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/transactions', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'business-finance/wallet-43', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/wallet-44', sizes: [16, 24, 32, 48, 64] },
      { name: 'business-finance/wallet-90', sizes: [24, 32, 48, 64] },
    ],
  },
  {
    name: 'Desing/Development',
    icons: [
      { name: 'desing-development/3d-29', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/3d-model', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/ai-generated-img', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/album', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/align-bottom', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/align-center-horizontal', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/align-center-vertical', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/align-left', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/align-right', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/align-top', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/android', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/angle', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/animation-14', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/animation-31', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/animation-32', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/api', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/app', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/app-store', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/apple', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/apps', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/arrow-tool', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/artboard', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/binary-code', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/blend', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/block', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/blockchain', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/board-2', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/book-bookmark', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/book-bookmark-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/book-open', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/book-open-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/border', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/border-radius', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/border-width', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/browser-edge', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-edge-legacy', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-firefox', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-chrome', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-ie', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-opera', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/browser-safari', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/brush', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/bucket', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/bullet-list-67', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/bullet-list-68', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/bullet-list-69', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/bullet-list-70', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/button-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/canvas', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cards', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/clone', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/code', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/code-editor', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/collection', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/command', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/compare-items', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/compass', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/components', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/contrast-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/copy', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/creative-commons', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/crop', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/css3', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-48', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-49', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-grab', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-load', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-menu', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-not-allowed', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-pointer', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/cursor-text', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/data-table', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/decision-process', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/depth', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/design', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/design-dev', sizes: [32, 48, 64] },
      { name: 'desing-development/design-system', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/digital-image', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/distribute-horizontal', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/distribute-vertical', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/divider', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/drag', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/drop-15', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/duplicate', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/edit-curves', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/edit-levels', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/empty', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/eraser-32', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/filter-organization', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/flip-horizontal', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/flip-vertical', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/floors', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/form', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/frame', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/function', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/geometry', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/git-commit', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/gradient', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/grain-effect', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/graphics-tablet', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/grid-system', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/group', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/hash-mark', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/height-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/hot-key', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/html5', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/image', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/image-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/img-stack', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/invert-process', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/js-console', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/json-logo', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/ladybug', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/layers', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/layers-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/layout', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/layout-11', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/layout-25', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/layout-grid', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/license-key', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/magic-wand', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/magnet', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/markdown', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/marker', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/mask-oval', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/mask-rect', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/measure-02', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/measure-17', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/measure-big', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/microsoft', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/mirror-display', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/mirror-tablet-phone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/mobile-design', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/mobile-dev', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/mobile-phone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/mouse', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/mouse-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/move', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/move-down-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/move-up-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/newsletter-dev', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/note', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/note-code', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/octagon', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/octagon-m', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-16', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-37', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-38', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-brush', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-bucket-39', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paint-bucket-40', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/palette', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/pantone', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/paper-design', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/paper-dev', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/paragraph-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/path-exclude', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/path-intersect', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/path-minus', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/path-unite', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/patch-19', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/patch-34', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/pc-mouse', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/pen-01', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/pen-23', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/pen-tool', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/photo-album', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/photo-editor', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/pilcrow', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/plug-2', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/position', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/priority-high', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/priority-highest', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/priority-low', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/priority-lowest', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/priority-normal', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/prototype', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/refresh-02', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/responsive', sizes: [32, 48, 64] },
      { name: 'desing-development/roadmap', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/row-table', sizes: [12, 24, 32, 48, 64] },
      { name: 'desing-development/ruler-pencil', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/scale-2', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/scale-down', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/scale-up', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/scissors', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/scissors-dashed', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/selection', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-adjust', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-arrow', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-circle', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-custom', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-line', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-oval', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-polygon', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-polygon-2', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-rectangle', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-square', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-star', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-triangle', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shape-triangle-2', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/shapes', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/sharpener', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/sidebar', sizes: [12, 24, 32, 48, 64] },
      { name: 'desing-development/size-large', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/size-medium', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/size-small', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/slice', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/slider', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/space-divider', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/sparks', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/spray-can', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/stack', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/stamp', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/style', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/tablet-mobile', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/texture', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/three-dimensional-object', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/time-machine', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/timeline', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/todo', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/tool-blur', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/tool-hand', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/tool-select', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/transactions', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/transform', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/transform-2d', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/transform-origin', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/transparent', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/type-tool', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/typography', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/ungroup', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/usb', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/vector', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/vibrance', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/wand', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/watch-dev', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/web-design', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/webpage', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/width', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/window-code', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/window-dev', sizes: [24, 32, 48, 64] },
      { name: 'desing-development/window-paragraph', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/window-responsive', sizes: [16, 24, 32, 48, 64] },
      { name: 'desing-development/wireframe', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'desing-development/zoom', sizes: [12, 16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Education',
    icons: [
      { name: 'education/abc', sizes: [24, 32, 48, 64] },
      { name: 'education/agenda', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/agenda-bookmark', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/album', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/astronomy', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/atom', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/award-49', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/backpack-57', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/backpack-58', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/basketball', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/biochemistry', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/biology', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/board-27', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/board-51', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/book', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/book-39', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/book-bookmark', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/book-bookmark-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/book-open', sizes: [24, 32, 48, 64] },
      { name: 'education/book-open-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/bookmark', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/books', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/books-46', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/botany', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/brush', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/bus', sizes: [24, 32, 48, 64] },
      { name: 'education/bus-front-12', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/buzz', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/calculator', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/certificate', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/cockade', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/collection', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/compass', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/design', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/earth-science', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/ecology', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/equation', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/eraser-32', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/eraser-33', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/flask', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/function', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/geometry', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/glasses', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/glasses-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/globe', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/globe-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/grammar-check', sizes: [24, 32, 48, 64] },
      { name: 'education/hat-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/chalkboard', sizes: [24, 32, 48, 64] },
      { name: 'education/chemistry', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/language', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/logic', sizes: [24, 32, 48, 64] },
      { name: 'education/marker', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/math', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/measure-02', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/measure-17', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/measure-big', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/medal', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/medicine', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/microbiology', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/microscope', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/molecule', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/notepad', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/notes', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/notification', sizes: [24, 32, 48, 64] },
      { name: 'education/open-book', sizes: [24, 32, 48, 64] },
      { name: 'education/paper', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/paper-diploma', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/paw', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pc-play-media', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pen-01', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pen-23', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pen-tool', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pencil', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pencil-47', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/pendulum', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/planet', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/potion', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/presentation', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/rat', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/read', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/reading', sizes: [24, 32, 48, 64] },
      { name: 'education/research', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/saved-items', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/school', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/soccer-ball', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/statistics', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'education/survey', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/telescope', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/translation', sizes: [16, 24, 32, 48, 64] },
      { name: 'education/typography', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Emoji',
    icons: [
      { name: 'emoji/alien-29', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/angry-10', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/angry-44', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/big-eyes', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/big-smile', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/bigmouth', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/bleah', sizes: [24, 32, 48, 64] },
      { name: 'emoji/bomb', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/bored', sizes: [24, 32, 48, 64] },
      { name: 'emoji/broken-heart', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/bug', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/cake', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/cry-15', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/cry-57', sizes: [24, 32, 48, 64] },
      { name: 'emoji/cute', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/devil', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/disgusted', sizes: [24, 32, 48, 64] },
      { name: 'emoji/dizzy-face', sizes: [24, 32, 48, 64] },
      { name: 'emoji/fairy-wand', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/finger-snap', sizes: [24, 32, 48, 64] },
      { name: 'emoji/fist', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/ghost', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/happy-sun', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/heart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'emoji/child', sizes: [24, 32, 48, 64] },
      { name: 'emoji/kid', sizes: [24, 32, 48, 64] },
      { name: 'emoji/kiss', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/laugh-17', sizes: [24, 32, 48, 64] },
      { name: 'emoji/laugh-35', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/lips', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/mad-12', sizes: [24, 32, 48, 64] },
      { name: 'emoji/mad-58', sizes: [24, 32, 48, 64] },
      { name: 'emoji/malicious', sizes: [24, 32, 48, 64] },
      { name: 'emoji/manga-62', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/manga-63', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/mask-face', sizes: [24, 32, 48, 64] },
      { name: 'emoji/monster', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/nerd', sizes: [24, 32, 48, 64] },
      { name: 'emoji/ninja', sizes: [24, 32, 48, 64] },
      { name: 'emoji/no-words', sizes: [24, 32, 48, 64] },
      { name: 'emoji/parrot', sizes: [24, 32, 48, 64] },
      { name: 'emoji/party', sizes: [24, 32, 48, 64] },
      { name: 'emoji/penguin', sizes: [24, 32, 48, 64] },
      { name: 'emoji/pirate', sizes: [24, 32, 48, 64] },
      { name: 'emoji/poop', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/puzzled', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/quite-happy', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/robot', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/rock', sizes: [24, 32, 48, 64] },
      { name: 'emoji/sad', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/satisfied', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/shark', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/shy', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/sick', sizes: [24, 32, 48, 64] },
      { name: 'emoji/silly', sizes: [24, 32, 48, 64] },
      { name: 'emoji/skull', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/sleep', sizes: [24, 32, 48, 64] },
      { name: 'emoji/sleep-2', sizes: [24, 32, 48, 64] },
      { name: 'emoji/sloth', sizes: [24, 32, 48, 64] },
      { name: 'emoji/smart', sizes: [24, 32, 48, 64] },
      { name: 'emoji/smile', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'emoji/smiling-face-glasses', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/smiling-face-sunglasses', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/soldier', sizes: [24, 32, 48, 64] },
      { name: 'emoji/speechless', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/spiteful', sizes: [24, 32, 48, 64] },
      { name: 'emoji/sunglasses-48', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/surprise', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/thumb-down', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/thumb-up', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/upset-13', sizes: [24, 32, 48, 64] },
      { name: 'emoji/upset-14', sizes: [24, 32, 48, 64] },
      { name: 'emoji/what', sizes: [16, 24, 32, 48, 64] },
      { name: 'emoji/whiskers', sizes: [24, 32, 48, 64] },
      { name: 'emoji/wink-06', sizes: [24, 32, 48, 64] },
      { name: 'emoji/wink-11', sizes: [24, 32, 48, 64] },
      { name: 'emoji/wink-69', sizes: [24, 32, 48, 64] },
    ],
  },
  {
    name: 'Energy',
    icons: [
      { name: 'energy/battery', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/battery-charging', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/battery-level', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/battery-low', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/battery-power', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/battery-status', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/botany', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/bulb', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/bulb-saver', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/car', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/clover', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/drop', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/eco-home', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/ecology', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/factory', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/forest', sizes: [24, 32, 48, 64] },
      { name: 'energy/fuel', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/fuel-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/fuel-electric', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/globe', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/humidity-52', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/hybrid-car', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/leaf', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/light-switch', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/money-growth', sizes: [24, 32, 48, 64] },
      { name: 'energy/oil', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/panel', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/plant-leaf', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/plant-soil', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/plant-vase', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/plug', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/plug-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/power-level', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/progress', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/radiation', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/recycling', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/refresh', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/reload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/save-planet', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/shower', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/sink-faucet', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/sun', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'energy/temperature', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/temperature-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/tree-01', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/waste', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/waste-danger', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/waste-recycling', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/water', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/water-hand', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/water-sink', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/wind', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/windmill', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/windmill-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'energy/world', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Files/Folders',
    icons: [
      { name: 'files-folders/backup', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/browse', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/clear-data', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/compressed-file', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/document', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/document-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/document-copy', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/file', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/file-add', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-article', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-audio', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-copies', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/file-copy', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-delete', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-export', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-favorite', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-font', sizes: [32, 48, 64] },
      { name: 'files-folders/file-gallery', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-gif', sizes: [32, 48, 64] },
      { name: 'files-folders/file-gpx', sizes: [32, 48, 64] },
      { name: 'files-folders/file-gzip', sizes: [32, 48, 64] },
      { name: 'files-folders/file-history', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-html', sizes: [32, 48, 64] },
      { name: 'files-folders/file-ics', sizes: [32, 48, 64] },
      { name: 'files-folders/file-image', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-info', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-iso', sizes: [32, 48, 64] },
      { name: 'files-folders/file-jar', sizes: [32, 48, 64] },
      { name: 'files-folders/file-java', sizes: [32, 48, 64] },
      { name: 'files-folders/file-jpg', sizes: [32, 48, 64] },
      { name: 'files-folders/file-js', sizes: [32, 48, 64] },
      { name: 'files-folders/file-json', sizes: [32, 48, 64] },
      { name: 'files-folders/file-jsp', sizes: [32, 48, 64] },
      { name: 'files-folders/file-link', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-locked', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-log', sizes: [32, 48, 64] },
      { name: 'files-folders/file-max', sizes: [32, 48, 64] },
      { name: 'files-folders/file-md', sizes: [32, 48, 64] },
      { name: 'files-folders/file-mkv', sizes: [32, 48, 64] },
      { name: 'files-folders/file-money', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-mov', sizes: [32, 48, 64] },
      { name: 'files-folders/file-mp3', sizes: [32, 48, 64] },
      { name: 'files-folders/file-mp4', sizes: [32, 48, 64] },
      { name: 'files-folders/file-mpg', sizes: [32, 48, 64] },
      { name: 'files-folders/file-no-access', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-obj', sizes: [32, 48, 64] },
      { name: 'files-folders/file-otf', sizes: [32, 48, 64] },
      { name: 'files-folders/file-pdf', sizes: [32, 48, 64] },
      { name: 'files-folders/file-php', sizes: [32, 48, 64] },
      { name: 'files-folders/file-play', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-png', sizes: [32, 48, 64] },
      { name: 'files-folders/file-pptx', sizes: [32, 48, 64] },
      { name: 'files-folders/file-preferences', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-psd', sizes: [32, 48, 64] },
      { name: 'files-folders/file-py', sizes: [32, 48, 64] },
      { name: 'files-folders/file-question', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-rar', sizes: [32, 48, 64] },
      { name: 'files-folders/file-raw', sizes: [32, 48, 64] },
      { name: 'files-folders/file-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/file-replace', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-rss', sizes: [32, 48, 64] },
      { name: 'files-folders/file-rtf', sizes: [32, 48, 64] },
      { name: 'files-folders/file-ruby', sizes: [32, 48, 64] },
      { name: 'files-folders/file-search', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-settings', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-shared', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-sketch', sizes: [32, 48, 64] },
      { name: 'files-folders/file-sql', sizes: [32, 48, 64] },
      { name: 'files-folders/file-srt', sizes: [32, 48, 64] },
      { name: 'files-folders/file-starred', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-svg', sizes: [32, 48, 64] },
      { name: 'files-folders/file-sync', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-text', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/file-tif', sizes: [32, 48, 64] },
      { name: 'files-folders/file-tiff', sizes: [32, 48, 64] },
      { name: 'files-folders/file-ttf', sizes: [32, 48, 64] },
      { name: 'files-folders/file-txt', sizes: [32, 48, 64] },
      { name: 'files-folders/file-user', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-vector', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/file-vvt', sizes: [32, 48, 64] },
      { name: 'files-folders/file-wav', sizes: [32, 48, 64] },
      { name: 'files-folders/file-xlsx', sizes: [32, 48, 64] },
      { name: 'files-folders/file-xml', sizes: [32, 48, 64] },
      { name: 'files-folders/file-zip', sizes: [32, 48, 64] },
      { name: 'files-folders/folder-replace', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/folder-upload', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/folder-user', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/folder-vector', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/layers', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/news', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/note', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/notebook', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/paper', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/raw-image', sizes: [24, 32, 48, 64] },
      { name: 'files-folders/research', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/save-for-later', sizes: [16, 24, 32, 48, 64] },
      { name: 'files-folders/saved-items', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/upload-file', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'files-folders/zipped-file', sizes: [24, 32, 48, 64] },
    ],
  },
  {
    name: 'Multimedia',
    icons: [
      { name: 'multimedia/3d-glasses', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/adult-content', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/ai-generated-img', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/album', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/alpha-order', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/antenna', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/anti-shake', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/aperture', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/audio-description', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/audio-jack', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/audio-mixer', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/auto-flash', sizes: [24, 32, 64] },
      { name: 'multimedia/auto-flash-2', sizes: [24, 32, 64] },
      { name: 'multimedia/auto-focus', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/brightness', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/browse', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/btn-play', sizes: [24, 32, 64] },
      { name: 'multimedia/btn-play-1', sizes: [24, 32, 64] },
      { name: 'multimedia/btn-stop', sizes: [24, 32, 64] },
      { name: 'multimedia/button-eject', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/button-next', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/button-pause', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/button-play', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/button-power', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/button-previous', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/button-record', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/button-rewind', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/button-skip', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/button-stop', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/camcorder', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/camera', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/camera-2', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-3', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-flash', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-flashlight', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-focus', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-focus-2', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/camera-lens', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-roll', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/camera-screen', sizes: [24, 32, 64] },
      { name: 'multimedia/camera-shooting', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/camera-timer', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/clapperboard', sizes: [24, 32, 64] },
      { name: 'multimedia/clapperboard-2', sizes: [24, 32, 64] },
      { name: 'multimedia/clarinet', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/compact-camera', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/countdown', sizes: [24, 32, 64] },
      { name: 'multimedia/countdown-2', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/crop', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/cycle', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/digital-image', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/digital-piano', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/drums', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/earbuds', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/edit-color', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/edit-contrast', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/edit-curves', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/edit-levels', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/edit-saturation', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/event-ticket', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/expand', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/face-recognition', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/file-aac', sizes: [32, 64] },
      { name: 'multimedia/file-audio', sizes: [24, 32, 64] },
      { name: 'multimedia/file-avi', sizes: [32, 64] },
      { name: 'multimedia/file-bmp', sizes: [32, 64] },
      { name: 'multimedia/file-epub', sizes: [32, 64] },
      { name: 'multimedia/file-flash', sizes: [32, 64] },
      { name: 'multimedia/file-flv', sizes: [32, 64] },
      { name: 'multimedia/file-mkv', sizes: [32, 64] },
      { name: 'multimedia/file-mov', sizes: [32, 64] },
      { name: 'multimedia/file-mp3', sizes: [32, 64] },
      { name: 'multimedia/file-mp4', sizes: [32, 64] },
      { name: 'multimedia/file-mpg', sizes: [32, 64] },
      { name: 'multimedia/file-vvt', sizes: [32, 48, 64] },
      { name: 'multimedia/file-wav', sizes: [32, 48, 64] },
      { name: 'multimedia/film', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/flash-off', sizes: [24, 32, 64] },
      { name: 'multimedia/flash-off-2', sizes: [24, 32, 64] },
      { name: 'multimedia/folder-image', sizes: [24, 32, 64] },
      { name: 'multimedia/folder-music', sizes: [24, 32, 64] },
      { name: 'multimedia/frame-effect', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/full-screen', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/fullscreen', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/grain-effect', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/grid', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/guitar', sizes: [24, 32, 64] },
      { name: 'multimedia/headphones', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/headphones-2', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/headphones-3', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/headphones-mic', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/image', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/image-add', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/image-delete', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/image-location', sizes: [24, 32, 64] },
      { name: 'multimedia/img', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/img-rotate-left', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/img-rotate-right', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/img-stack', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/instant-camera', sizes: [24, 32, 64] },
      { name: 'multimedia/instant-camera-2', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/interview', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/kid-2', sizes: [24, 32, 64] },
      { name: 'multimedia/knob', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/layers-2', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/lightning', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/loudspeaker', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/love-movie', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/macro', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/media-player', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/media-stream', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/mic', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/mic-2', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/microphone', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/microphone-2', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/microphone-off', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/movie', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/movie-2', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/movie-3', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/movie-reel', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/music', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/music-album', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/music-cloud', sizes: [24, 32, 64] },
      { name: 'multimedia/music-note', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/music-playlist', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/night', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/no-photo', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/offline', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/options', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/pc-play-media', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/phone-camera-back', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/phone-music', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/photo', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/photo-album', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/photo-frame', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/photo-not-allowed', sizes: [24, 32, 64] },
      { name: 'multimedia/piano', sizes: [24, 32, 64] },
      { name: 'multimedia/piano-2', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/picture', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/play-media', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/play-movie', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/player', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/playlist', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/podcast', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/podcast-mic', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/polaroid', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/polaroid-photo', sizes: [16, 24, 32, 64] },
      { name: 'multimedia/polaroid-portrait', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/polaroid-shot-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/polaroid-shot-new', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/polaroid-shots', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/progress-indicator', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/projector', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/radio', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/random', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/raw-image', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/record-player', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/rotate-camera', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/rotate-left', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/rotate-right', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/save-to-list', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/saxophone', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/scale-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/screen-reader', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/screen-sharing-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/screen-sharing-off-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/screen-touch', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/sd-card', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/selfie', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/selfie-2', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/sharpen', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/sound', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/sound-wave', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/soundwave', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/sparks', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/speaker', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/speaker-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/sport-mode', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/sticker', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/subtitles', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/sun', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/tape', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/temperature', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/ticket', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/tool-blur', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/tripod', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/trumpet', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/vibrance', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/video', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/video-camera', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/video-gallery', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/video-gallery-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/video-off', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/video-player', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/video-playlist', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/vignette', sizes: [12, 16, 24, 32, 64] },
      { name: 'multimedia/violin', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/volume', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/volume-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'multimedia/volume-down', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/volume-mute', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/volume-off', sizes: [24, 32, 48, 64] },
      { name: 'multimedia/volume-up', sizes: [16, 24, 32, 48, 64] },
      { name: 'multimedia/white-balance', sizes: [12, 16, 24, 32, 64] },
    ],
  },
  {
    name: 'Shopping',
    icons: [
      { name: 'shopping/a-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/add-to-cart', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/add-to-cart-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/award', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-16', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-17', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-20', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-add-18', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-add-21', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-delivery', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-remove-19', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-remove-22', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bag-time', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/barcode', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/barcode-qr', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/barcode-scan', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/basket-add', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-edit', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-favorite', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-remove', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-search', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-share', sizes: [24, 32, 48, 64] },
      { name: 'shopping/basket-simple', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/basket-simple-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/basket-simple-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/basket-update', sizes: [24, 32, 48, 64] },
      { name: 'shopping/bill', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/billboard', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/bitcoin', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/board', sizes: [24, 32, 48, 64] },
      { name: 'shopping/box', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/box-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/box-3d-50', sizes: [24, 32, 48, 64] },
      { name: 'shopping/box-3d-67', sizes: [32, 48, 64] },
      { name: 'shopping/box-ribbon', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/businessman-04', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/card-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/card-favorite', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/card-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/card-update', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/cart-add', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-add-9', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-favorite', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cart-full', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-refresh', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-remove', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-remove-9', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cart-return', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cart-simple-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cart-simple-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cart-speed', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cash-register', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/contactless-card', sizes: [24, 32, 48, 64] },
      { name: 'shopping/coupon', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/credit-card', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/credit-card-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/credit-locked', sizes: [24, 32, 48, 64] },
      { name: 'shopping/currency-dollar', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/currency-euro', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/currency-exchange', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/currency-exchange-2', sizes: [24, 32, 48, 64] },
      { name: 'shopping/currency-pound', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/currency-yen', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/customer-support', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cut', sizes: [24, 32, 48, 64] },
      { name: 'shopping/delivery', sizes: [24, 32, 48, 64] },
      { name: 'shopping/delivery-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/delivery-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/delivery-fast', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/delivery-time', sizes: [24, 32, 48, 64] },
      { name: 'shopping/delivery-track', sizes: [24, 32, 48, 64] },
      { name: 'shopping/discount-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/farmer-market', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/hand-card', sizes: [24, 32, 48, 64] },
      { name: 'shopping/cheque', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cheque-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/cheque-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/label', sizes: [24, 32, 48, 64] },
      { name: 'shopping/lifering', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/list', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/market-music', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/market-play', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/mobile-banking', sizes: [24, 32, 48, 64] },
      { name: 'shopping/mobile-card', sizes: [24, 32, 48, 64] },
      { name: 'shopping/mobile-cart', sizes: [32, 48, 64] },
      { name: 'shopping/mobile-touch', sizes: [32, 48, 64] },
      { name: 'shopping/money-transfer', sizes: [24, 32, 48, 64] },
      { name: 'shopping/new', sizes: [24, 32, 48, 64] },
      { name: 'shopping/newsletter', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/online-banking', sizes: [24, 32, 48, 64] },
      { name: 'shopping/pallet', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/pallet-stacked-boxes', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/payment-method', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/percent-sign', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/percentage-38', sizes: [24, 32, 48, 64] },
      { name: 'shopping/personal-trainer', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/pos', sizes: [24, 32, 48, 64] },
      { name: 'shopping/present', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/receipt', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/receipt-list-42', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/receipt-list-43', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/refund', sizes: [24, 32, 48, 64] },
      { name: 'shopping/round-dollar', sizes: [24, 32, 48, 64] },
      { name: 'shopping/round-euro', sizes: [24, 32, 48, 64] },
      { name: 'shopping/round-pound', sizes: [24, 32, 48, 64] },
      { name: 'shopping/round-yen', sizes: [24, 32, 48, 64] },
      { name: 'shopping/sale', sizes: [24, 32, 48, 64] },
      { name: 'shopping/scale-4', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/shipping-container', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/shop', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/shop-location', sizes: [24, 32, 48, 64] },
      { name: 'shopping/shopping-bag', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/shopping-cart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/shopping-cart-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/shopping-label', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/shopping-tag', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/sign-24h', sizes: [32, 48, 64] },
      { name: 'shopping/sign-board', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/sign-closed', sizes: [32, 48, 64] },
      { name: 'shopping/sign-open', sizes: [32, 48, 64] },
      { name: 'shopping/size-large', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/size-medium', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/size-small', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/stock-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/stock-market', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/storage-unit', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/store', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/support', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/tag', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'shopping/tag-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/tag-cut', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/tag-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/tag-loyalty', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/tag-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/tag-sale', sizes: [24, 32, 48, 64] },
      { name: 'shopping/tags-stack', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/track-delivery', sizes: [24, 32, 48, 64] },
      { name: 'shopping/virtual-assistant-2', sizes: [24, 32, 48, 64] },
      { name: 'shopping/wallet', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/wallet-43', sizes: [16, 24, 32, 48, 64] },
      { name: 'shopping/wallet-44', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Technology',
    icons: [
      { name: 'technology/3d-printing', sizes: [24, 32, 48, 64] },
      { name: 'technology/ai', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/ai-generated-img', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/algorithm', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/android', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/antenna', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/api', sizes: [24, 32, 48, 64] },
      { name: 'technology/app-services', sizes: [24, 32, 48, 64] },
      { name: 'technology/apple', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/artificial-brain', sizes: [24, 32, 48, 64] },
      { name: 'technology/artificial-intelligence', sizes: [24, 32, 48, 64] },
      { name: 'technology/audio-jack', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/augmented-reality', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/automated-logistics', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/baby-monitor', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/battery-level', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/binary-code', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/block', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/blockchain', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cable', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cctv', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cd-reader', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cloud-mining', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/computer', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/computer-monitor', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/connection', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/contactless', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/content-360deg', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/content-delivery', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/control-panel', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/controller', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/controller-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cpu', sizes: [24, 32, 48, 64] },
      { name: 'technology/cryptography', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/cyborg', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/decentralize', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/decision-process', sizes: [24, 32, 48, 64] },
      { name: 'technology/device-connection', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/digital-image', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/digital-key', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/disk', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/disk-reader', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/drone', sizes: [24, 32, 48, 64] },
      { name: 'technology/drone-2', sizes: [24, 32, 48, 64] },
      { name: 'technology/e-reader', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/earbuds', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/electronic-circuit', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/engine-start', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/eye-recognition', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/face-recognition', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/firewall', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/gaming-console', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/gaming-controller', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/gopro', sizes: [32, 48, 64] },
      { name: 'technology/graphics-tablet', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/hacker', sizes: [24, 32, 48, 64] },
      { name: 'technology/hair-clipper', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/handheld-console', sizes: [24, 32, 48, 64] },
      { name: 'technology/hdmi', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/headphones', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/headphones-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/headphones-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/headset', sizes: [24, 32, 48, 64] },
      { name: 'technology/humanoid', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/hybrid-car', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/charger-cable', sizes: [24, 32, 48, 64] },
      { name: 'technology/chat-bot', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/keyboard', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/keyboard-hide', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/keyboard-mouse', sizes: [24, 32, 48, 64] },
      { name: 'technology/keyboard-wired', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/keyboard-wireless', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/l-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/l-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/l-location', sizes: [24, 32, 48, 64] },
      { name: 'technology/l-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/l-search', sizes: [24, 32, 48, 64] },
      { name: 'technology/l-security', sizes: [24, 32, 48, 64] },
      { name: 'technology/l-settings', sizes: [24, 32, 48, 64] },
      { name: 'technology/l-sync', sizes: [24, 32, 48, 64] },
      { name: 'technology/l-system-update', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/landscape-orientation', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/laptop', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/laptop-1', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/laptop-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/license-key', sizes: [24, 32, 48, 64] },
      { name: 'technology/live-streaming', sizes: [24, 32, 48, 64] },
      { name: 'technology/lock-landscape', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/lock-orientation', sizes: [24, 32, 48, 64] },
      { name: 'technology/lock-portrait', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/logic', sizes: [24, 32, 48, 64] },
      { name: 'technology/machine-learning', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/media-player', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/messaging', sizes: [24, 32, 48, 64] },
      { name: 'technology/metrics', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/mic', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/mic-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/migration', sizes: [24, 32, 48, 64] },
      { name: 'technology/mobile-banking', sizes: [24, 32, 48, 64] },
      { name: 'technology/mobile-chat', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/mobile-phone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/mouse', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/mouse-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/music-player', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/navigation', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/nodes', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/offline', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/online-banking', sizes: [24, 32, 48, 64] },
      { name: 'technology/open-ai', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-heart', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-location', sizes: [24, 32, 48, 64] },
      { name: 'technology/p-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-search', sizes: [24, 32, 48, 64] },
      { name: 'technology/p-settings', sizes: [24, 32, 48, 64] },
      { name: 'technology/p-share', sizes: [24, 32, 48, 64] },
      { name: 'technology/p-sync', sizes: [24, 32, 48, 64] },
      { name: 'technology/p-system-update', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/p-time', sizes: [24, 32, 48, 64] },
      { name: 'technology/parking-sensors', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/pattern-recognition', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/pc', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/pc-monitor', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/pc-mouse', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/pc-play-media', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/pci-card', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-button', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-camera-back', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-camera-front', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-dock', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-charging', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-charging-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-charging-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/phone-toolbar', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/plug', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/plug-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/print', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/printer', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/printer-p', sizes: [32, 48, 64] },
      { name: 'technology/printer-p-2', sizes: [32, 48, 64] },
      { name: 'technology/projector', sizes: [24, 32, 48, 64] },
      { name: 'technology/ram', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/ram-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/reading-tablet', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/redmine', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/remote-control', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/robot-cleaner', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/robotic-arm', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/router', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/satellite', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/satellite-dish', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/screen-reader', sizes: [24, 32, 48, 64] },
      { name: 'technology/screen-rotation', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/screen-sharing-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/screen-sharing-off-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/send-to-phone', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/sensor', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/server', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/server-rack', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/signal', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/sim-card', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/smart-house', sizes: [24, 32, 48, 64] },
      { name: 'technology/smartphone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/smartwatch', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/socket', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/socket-europe-1', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/socket-europe-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/socket-uk', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/sparks', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/ssd', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/sync-devices', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/system-update', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/tablet', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/tablet-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/tablet-charging', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/tablet-toolbar', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/three-dimensional-object', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/three-dimensional-world', sizes: [24, 32, 48, 64] },
      { name: 'technology/traffic', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/transactions', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/translation', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/tv', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/tv-stand', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/usb', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/video-off', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/video-player', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/vintage-computer', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/vintage-tv', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/virtual-assistant', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/virtual-assistant-2', sizes: [24, 32, 48, 64] },
      { name: 'technology/virtual-environment', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/virtual-reality', sizes: [24, 32, 48, 64] },
      { name: 'technology/voice-recognition', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/vpn', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/vr-controller', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/vr-headset', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/watch', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/watch-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/webcam', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/webcam-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/wifi', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'technology/wifi-2', sizes: [24, 32, 48, 64] },
      { name: 'technology/wifi-off', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/wifi-protected', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/wifi-router', sizes: [16, 24, 32, 48, 64] },
      { name: 'technology/wireless-charging', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Transportation',
    icons: [
      { name: 'transportation/air-baloon', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/airbag', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/airplane', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/alien-33', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/anchor', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/baby-car-seat', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/battery-level', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/bike', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/bike-bmx', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/boat', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/boat-front', sizes: [24, 32, 48, 64] },
      { name: 'transportation/boat-small-02', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/boat-small-03', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/brakes', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/bus', sizes: [24, 32, 48, 64] },
      { name: 'transportation/bus-front-10', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/bus-front-12', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-accident', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-connect', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-door', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-front', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/car-lights', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-parking', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-simple', sizes: [24, 32, 48, 64] },
      { name: 'transportation/car-sport', sizes: [24, 32, 48, 64] },
      { name: 'transportation/car-ventilation', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/car-wash', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/cone', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/control-panel', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/cycling', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/dashboard', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/delivery', sizes: [24, 32, 48, 64] },
      { name: 'transportation/drone', sizes: [24, 32, 48, 64] },
      { name: 'transportation/drone-2', sizes: [24, 32, 48, 64] },
      { name: 'transportation/engine', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/engine-start', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/flight', sizes: [24, 32, 48, 64] },
      { name: 'transportation/flip-up', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/fuel', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/fuel-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/fuel-electric', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/helicopter', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/helmet', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/hybrid-car', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/landing', sizes: [24, 32, 48, 64] },
      { name: 'transportation/light-traffic', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/love-car', sizes: [24, 32, 48, 64] },
      { name: 'transportation/moto', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/oil', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/parking', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/parking-sensors', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/plane', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/power-level', sizes: [24, 32, 48, 64] },
      { name: 'transportation/racing-bike', sizes: [32, 48, 64] },
      { name: 'transportation/rim', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/road', sizes: [24, 32, 48, 64] },
      { name: 'transportation/road-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/scooter', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/seat', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/seatbelt', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/sensor', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/shuttle', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/skateboard', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/skateboard-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/speedometer', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'transportation/steering-wheel', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/stop-sign', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/submarine', sizes: [24, 32, 48, 64] },
      { name: 'transportation/take-off', sizes: [24, 32, 48, 64] },
      { name: 'transportation/taxi', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/tractor', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/train', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/train-speed', sizes: [24, 32, 48, 64] },
      { name: 'transportation/tram', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/truck-front', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/trunk', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/ventilation', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/vespa', sizes: [24, 32, 48, 64] },
      { name: 'transportation/vespa-front', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/walk', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/washing-fluid', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/wheel', sizes: [16, 24, 32, 48, 64] },
      { name: 'transportation/wheel-2', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'User Interface',
    icons: [
      { name: 'user-interface/a-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/a-chat', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/a-tag', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/a-tag-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/a-tag-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/access-key', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-fav', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-favorite', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-like', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-notification', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-to-cart', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/add-to-cart-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/alarm', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/alarm-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/alarm-disable', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/analytics', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/app-store', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/apps', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/archive', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/archive-drawer', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/at-sign', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/attach', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/attachment', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/b-comment', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/b-eye', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/b-chart', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/backward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/ban', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/basket', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/battery-charging', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/battery-low', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/battery-power', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/battery-status', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bell', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bin', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/blog', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/bluetooth', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/board-2', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/bolt', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/book', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmark', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmark-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmark-add-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmark-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmark-delete-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bookmarks', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/bullet-list', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/buzz', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/c-add', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/c-delete', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/c-edit', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/c-check', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/c-info', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/c-pulse', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/c-question', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/c-remove', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/c-warning', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-date', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-date-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-day-view', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-event', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-event-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/calendar-event-create', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/clear-data', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/clock', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/cloud', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/cloud-forecast', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/cogwheel', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/comment', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/comment-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/comments', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/compare-items', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/components', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/configuration', sizes: [32, 64] },
      { name: 'user-interface/configuration-tool', sizes: [32, 64] },
      { name: 'user-interface/configuration-tools', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/control-panel', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/d-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/d-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/d-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/d-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/d-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/d-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/dashboard', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/data-download', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/data-settings', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/data-upload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/database', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/delete-forever', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/design-system', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/disk', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/dock-bottom', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/dock-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/dock-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/dock-top', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/download', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/drop', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/e-add', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/e-delete', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/e-remove', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/edit-note', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/email', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/email-open', sizes: [12, 24, 32, 48] },
      { name: 'user-interface/empty', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/enlarge', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/event-confirm', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/event-create', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/exclamation-mark', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/eye', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-comment', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-dashboard', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-chat', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/f-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/fav-list', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/fav-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/favorite', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/feedback', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/file-add', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/file-article', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/file-delete', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/file-text', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/filter', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/filter-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/filter-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/filter-tool', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/find-replace', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/flame', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/floors', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/floppy-disk', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/forward', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/full-screen', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/fullsize', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/funnel', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/g-chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/g-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/gallery-layout', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/gallery-view', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/gantt', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/gear', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/geometry', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/grid-interface', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/grid-layout', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/grid-view', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/heart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/hide', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/home', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/home-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/home-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/hot-key', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/hotspot', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/hourglass', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/house', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/hyperlink', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/hyperlink-broken', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/chain', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/chart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/chat', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/check', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/check-all', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/check-double', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/check-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/check-list', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/check-out', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/check-single', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/checkbox-btn', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/checkbox-btn-checked', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/chemistry', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/i-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/i-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/i-edit', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/i-check', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/i-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/incognito', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/increase', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/infinite', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/info', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/key', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/label', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/layout', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/layout-grid', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/leaf', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/leave', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/letter', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/lifering', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/light-control', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/like', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/link', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/lock', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/log-out', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/magnifier', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/magnifier-zoom-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/magnifier-zoom-out', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/mail', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/megaphone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-3', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-4', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-6', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-7', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-8', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/menu-dots', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/metrics', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/mirror-tablet-phone', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/n-edit', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/n-check', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/network-communication', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/network-connection', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/networking', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/new-notification', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/news', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/no-results', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/note', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/notification', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/notification-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/o-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/o-warning', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/offline', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/opening-times', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/options', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/p-chart', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/padlock', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/padlock-unlocked', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/paragraph', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/password', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/pen', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/pen-2', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/pencil', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/phone', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/phone-call', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/phone-call-end', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/plant-leaf', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/playlist', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/preferences', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/present', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/privacy', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/privacy-settings', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/progress-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/progress-indicator', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/question-mark', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/questionnaire', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/r-chat', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/radio-btn', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/radio-btn-checked', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/remove-fav', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/remove-favorite', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/remove-like', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/roadmap', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/s-add', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/s-ban', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/s-delete', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/s-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/s-check', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/s-info', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/s-pulse', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/s-question', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/s-remove', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/s-warning', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/save-for-later', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/save-to-list', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/saved-items', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/screen-enlarge', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/screen-expand', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/screen-maximize', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/screen-sharing-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/screen-sharing-off-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/search', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/search-content', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/search-zoom-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/search-zoom-out', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/security', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/segmentation', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/select', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/send', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/send-message', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/settings', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/settings-gear', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/settings-wheel', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/setup-options', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/setup-preferences', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/setup-tools', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/share', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/sharing', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/shop', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/shopping-bag', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/shopping-cart', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/shopping-cart-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/shopping-label', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/shopping-tag', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/sidebar', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/slide-left', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/slide-right', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/social-sharing', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/sort-tool', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/spaceship', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/speedometer', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/stack', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/star', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/star-rate', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/stopwatch', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/support', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/survey', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/switches', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/system-configuration', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/system-preferences', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/t-add', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/t-delete', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/t-remove', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/table-layout', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/table-move', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/table-slide', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/tag', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/tags-stack', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/target', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/telephone', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/time-alarm', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/time-clock', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/time-machine', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/timeline', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/toggle', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/translation', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/trash', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/trash-can', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/unlink', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/unlocked', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/upload', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/url', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/verified', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/video-gallery', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/view', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/virtual-assistant-2', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/warning-sign', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/web-hyperlink', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/web-link', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/web-url', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/webpage', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/widget', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/window-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/window-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/wireframe', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/wrench', sizes: [24, 32, 48, 64] },
      { name: 'user-interface/wrench-tool', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/zoom', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'user-interface/zoom-in', sizes: [16, 24, 32, 48, 64] },
      { name: 'user-interface/zoom-out', sizes: [16, 24, 32, 48, 64] },
    ],
  },
  {
    name: 'Users',
    icons: [
      { name: 'users/accessibility', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/account', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'users/address-book', sizes: [24, 32, 48, 64] },
      { name: 'users/contact', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/contact-list', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/contacts', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/couple-gay', sizes: [24, 32, 48, 64] },
      { name: 'users/couple-lesbian', sizes: [24, 32, 48, 64] },
      { name: 'users/diaper-changing-area', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/doctor', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/exchange', sizes: [24, 32, 48, 64] },
      { name: 'users/face-man', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/face-woman', sizes: [24, 32, 48, 64] },
      { name: 'users/family', sizes: [24, 32, 48, 64] },
      { name: 'users/family-roof', sizes: [24, 32, 48, 64] },
      { name: 'users/farmer', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/female-figure', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/female-sign', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/file-shared', sizes: [24, 32, 48, 64] },
      { name: 'users/file-user', sizes: [24, 32, 48, 64] },
      { name: 'users/folder-shared', sizes: [24, 32, 48, 64] },
      { name: 'users/folder-user', sizes: [24, 32, 48, 64] },
      { name: 'users/gathering-restrictions', sizes: [24, 32, 48, 64] },
      { name: 'users/grandparent', sizes: [24, 32, 48, 64] },
      { name: 'users/hacker', sizes: [24, 32, 48, 64] },
      { name: 'users/hair-man', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/hair-woman', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/humanoid', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/child', sizes: [24, 32, 48, 64] },
      { name: 'users/info-point', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/interview', sizes: [24, 32, 48, 64] },
      { name: 'users/joint-account', sizes: [24, 32, 48, 64] },
      { name: 'users/male-sign', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/man', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/man-arrow-down', sizes: [24, 32, 48, 64] },
      { name: 'users/man-arrow-up', sizes: [24, 32, 48, 64] },
      { name: 'users/man-profile', sizes: [24, 32, 48, 64] },
      { name: 'users/meeting', sizes: [24, 32, 48, 64] },
      { name: 'users/mickey-mouse', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/miner', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/mobile-contact', sizes: [24, 32, 48, 64] },
      { name: 'users/negative-judgement', sizes: [24, 32, 48, 64] },
      { name: 'users/no-contact', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/office-badge', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/office-pass', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'users/parenting', sizes: [24, 32, 48, 64] },
      { name: 'users/payee', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/payor', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/people-network', sizes: [24, 32, 48, 64] },
      { name: 'users/police-officer', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/positive-judgement', sizes: [24, 32, 48, 64] },
      { name: 'users/pregnant-woman', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/privacy-policy', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/profile', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'users/property', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/reading', sizes: [24, 32, 48, 64] },
      { name: 'users/search-user', sizes: [24, 32, 48, 64] },
      { name: 'users/security-gate', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/security-officer', sizes: [24, 32, 48, 64] },
      { name: 'users/social-distancing', sizes: [24, 32, 48, 64] },
      { name: 'users/standing-man', sizes: [24, 32, 48, 64] },
      { name: 'users/standing-woman', sizes: [24, 32, 48, 64] },
      { name: 'users/stay-home', sizes: [24, 32, 48, 64] },
      { name: 'users/team', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/toilette', sizes: [24, 32, 48, 64] },
      { name: 'users/user', sizes: [12, 16, 24, 32, 48, 64] },
      { name: 'users/user-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-add', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-bubble', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-c-frame', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-c-frame-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-c-frame-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-create', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-delete', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-delete-cross', sizes: [24, 32, 48, 64] },
      { name: 'users/user-delete-line', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-edit', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-focus', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-group', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-heart', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-check', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-list', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-location', sizes: [24, 32, 48, 64] },
      { name: 'users/user-location-2', sizes: [24, 32, 48, 64] },
      { name: 'users/user-lock', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-new', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-remove', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-s-frame', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-s-frame-2', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-s-frame-3', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/user-search', sizes: [24, 32, 48, 64] },
      { name: 'users/user-share', sizes: [24, 32, 48, 64] },
      { name: 'users/user-star', sizes: [24, 32, 48, 64] },
      { name: 'users/user-sync', sizes: [24, 32, 48, 64] },
      { name: 'users/user-time', sizes: [24, 32, 48, 64] },
      { name: 'users/user-wearing-glasses', sizes: [24, 32, 48, 64] },
      { name: 'users/users', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/users-add', sizes: [24, 32, 48, 64] },
      { name: 'users/users-heart', sizes: [24, 32, 48, 64] },
      { name: 'users/users-check', sizes: [24, 32, 48, 64] },
      { name: 'users/users-location', sizes: [24, 32, 48, 64] },
      { name: 'users/users-lock', sizes: [24, 32, 48, 64] },
      { name: 'users/users-meeting', sizes: [24, 32, 48, 64] },
      { name: 'users/users-mm', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/users-remove', sizes: [24, 32, 48, 64] },
      { name: 'users/users-wm', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/users-ww', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/virtual-assistant-2', sizes: [24, 32, 48, 64] },
      { name: 'users/voice-record', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/wc-sign', sizes: [24, 32, 48, 64] },
      { name: 'users/wheelchair', sizes: [16, 24, 32, 48, 64] },
      { name: 'users/woman', sizes: [24, 32, 48, 64] },
      { name: 'users/woman-arrow-down', sizes: [24, 32, 48, 64] },
      { name: 'users/woman-arrow-up', sizes: [24, 32, 48, 64] },
      { name: 'users/woman-man', sizes: [24, 32, 48, 64] },
      { name: 'users/woman-profile', sizes: [24, 32, 48, 64] },
      { name: 'users/work-badge', sizes: [16, 24, 32, 48, 64] },
    ],
  },
]
